import { ModelBase, observable } from "@shoothill/core";
import { InductionQualificationDTO } from "../../InductionAdminItemModel";

export class QualificationEditModel extends ModelBase<QualificationEditModel> {
    @observable
    public id: string | null = null;

    @observable
    public inductionUserId: string = "";

    @observable
    public inductionSectionTypeId: string = "";

    @observable
    public name: string = "";

    @observable
    public passed: boolean | null = null;

    @observable
    public typeLevel: string = "";

    @observable
    public idRollNumber: string = "";

    @observable
    public expiryDate: string | null = "";

    @observable
    public photoEvidenceData: string = "";

    @observable
    public photoEvidenceFileName: string = "";

    @observable
    public photoEvidenceUrl: string = "";

    fromDto(dto: any): void {
        for (const key in dto) {
            if (dto.hasOwnProperty(key)) {
                this[key] = dto[key];
            }
        }
    }

    toDto(): InductionQualificationDTO {
        return {
            id: this.id,
            inductionUserId: this.inductionUserId,
            inductionSectionTypeId: this.inductionSectionTypeId,
            name: this.name,
            passed: this.passed,
            typeLevel: this.typeLevel,
            idRollNumber: this.idRollNumber,
            expiryDate: this.expiryDate || "",
            photoEvidenceData: this.photoEvidenceData,
            photoEvidenceFileName: this.photoEvidenceFileName,
            photoEvidenceUrl: this.photoEvidenceUrl,
            photoEvidenceUrlInline: "",
        };
    }
}
